import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { SwiperConfig } from '../directive/swiper.directive';

@Component({
    selector: 'app-product-banner-carousel',
    templateUrl: './product-banner-carousel.component.html',
    styleUrls: ['./product-banner-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductBannerCarouselComponent implements OnInit {
  @Input('slides') slides: Array<any> = [];
  public config: SwiperConfig = {};
  private pagination: SwiperConfig['pagination'] = {
    el: '.swiper-pagination',
    clickable: true
  };
  constructor(
   
  ) { }
  ngOnInit() { 
    
  }
  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 5,
      keyboard: true,
      navigation: true,
      pagination: this.pagination,
      grabCursor: true,
      loop: false,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: "slide"
    }
  }
}

